export default function Footer() {
    const year = new Date().getFullYear();
  
    return (
      <footer className="site-footer">
        <span className="site-footer-copyright">
          © {year} positivegrain
        </span>
      </footer>
    );
  }